<template>
  <div class="CancleSubscription">
    <p class="Tips">
      {{ $t('subscription_details.subAccordion.cancel.confirmText', 'Are you sure you want to cancel your subscription? If yes, please click the button below, thanks!') }}
    </p>

    <app-button
      type="submit"
      @click.prevent="trackConversion({ name: 'interaction', description: 'cancel_subscription' });$bus.$emit('open-modal', 'replenishmentCancel')"
      :is-loading="cancelReplenishmentTask.isActive"
      data-name="cancelSubscription-submitButton"
    >
      {{ $t('subscription_details.subAccordion.cancel.button', 'Cancel your subscription') }} ›
    </app-button>

    <app-modal name="replenishmentCancel" width="500">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.cancelReplenishment.confirmationModal.title', 'Cancel replenishment') }}
        </h3>

        <div class="modal-content">
          <p>
            {{ $t('subscription_details.cancelReplenishment.confirmationModal.text', 'Are you sure you want to cancel the product?') }}
          </p>

          <div class="modal-button-warpper">
            <app-button
              type="submit"
              @click.prevent="cancelReplenishmentTask.run()"
            >
              {{ $t('subscription_details.cancelReplenishment.confirmationModal.button.ok', 'Ok') }}
            </app-button>

            <app-button @click="$bus.$emit('close-modal', 'replenishmentCancel')">
              {{ $t('subscription_details.cancelReplenishment.confirmationModal.button.cancel', 'Cancel') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'replenishment-cancel',

    props: {
      subscriptionNumber: {
        type: String,
        required: true
      },

      subscriptionRatePlanId: {
        type: String,
        required: true
      }
    },

    tasks (t) {
      return {
        cancelReplenishmentTask: t(async function () {
          this.$bus.$emit('close-modal', 'replenishmentCancel')

          await Vue.api.subscription.cancelReplenishment(this.subscriptionNumber, this.subscriptionRatePlanId)
          this.$notify({
            type: 'success',
            title: this.$t('popuptips.cancelSubscription.request.sent', 'Cancel subscription is being processed!')
          })

          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('drop')
      }
    }
  }
</script>
